import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles/createTheme';

export const ThemeMUIDataTable: Components<Omit<Theme, 'components'>>['MUIDataTable'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none !important',
    },
  },
};

export const ThemeMUIDataTableToolbar: Components<Omit<Theme, 'components'>>['MUIDataTableToolbar'] = {
  styleOverrides: {
    titleText: {
      fontSize: 14,
      fontWeight: 600,
    },
  },
};

export const ThemeMUIDataTableBodyCell: Components<Omit<Theme, 'components'>>['MUIDataTableBodyCell'] = {
  styleOverrides: {
    root: {
      backgroundColor: '#fff !important',
    },
  },
};

export const ThemeMUIDataTableBodyRow: Components<Omit<Theme, 'components'>>['MUIDataTableBodyRow'] = {
  styleOverrides: {
    root: {
      '&:has(+ .MuiTableRowExpanded)': {
        background: '#EFF6FF',
        '& > td': {
          borderBottom: 'none',
        }
      }
    }
  }
}

export const ThemeMUIDataTableHeadCell: Components<Omit<Theme, 'components'>>['MUIDataTableHeadCell'] = {
  styleOverrides: {
    root: {
      backgroundColor: '#f8f9fa',
    },
  },
};

export const ThemeMUIDataTableSelectCell: Components<Omit<Theme, 'components'>>['MUIDataTableSelectCell'] = {
  styleOverrides: {
    headerCell: {
      backgroundColor: '#f8f9fa',
    },
  },
};

export const ThemeMUIDataTablePagination: Components<Omit<Theme, 'components'>>['MUIDataTablePagination'] = {
  styleOverrides: {
    tableCellContainer: {
      borderBottom: 0,
    },
  },
};
